<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <button class="close close-btn" @click="close()">
              <i class="fas fa-times"></i>
            </button>
            <div class="row no-gutters">
              <div class="col-12">
                <p><strong class="title-text">Account Closure Request </strong></p>
              </div>
            </div>
          </div>
          <div class="modal-body" v-if="!isLoading">
            <div class="input-body">
              <div class="row" v-if="isSuccess">
                <div class="col-12">
                  <div class="status-icon success-icon">
                    <i class="fas fa-check"></i>
                  </div>
                </div>
                <div class="col-12">
                  <h3 class="status-title">Submitted!</h3>
                </div>
                <div class="col-12">
                  <p class="status-content">
                    Created <strong> {{successResponse.number}} </strong> -
                    <a target="_blank" :href="successResponse.url">Click here</a> to track the status of your request.
                  </p>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-12">
                  <div v-if="isFailure" class="alert alert-danger" role="alert">
                    <span>
                      An error has occurred while submitting your request. Please try again. If the problem persists, please contact support.
                    </span>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label >Account name</label>
                    <input type="text" class="form-control" disabled="disabled" v-model="account.accountCustomName" />
                  </div>
                  <div class="form-group">
                    <label >Account ID</label>
                    <input type="text" class="form-control" disabled="disabled" v-model="account.accountId" />
                  </div>
                  <div class="form-group">
                    <label >Requested For</label>
                    <input type="text" class="form-control" disabled="disabled" v-model="this.userName" />
                  </div>
                  <div class="form-group">
                    <label >Request Description * </label>
                    <textarea  type="text" class="form-control" v-model="requestDescription">
                    </textarea>
                    <em v-if="requestDescriptionError" class="required-text">* Request Description is required.</em>
                  </div>
                  <div class="form-group">
                    <input style="vertical-align: middle" type="checkbox" id="acceptance" name="acceptance" value="accepted" v-on:change="acceptRisks($event)" v-model="risksCheckBox">
                    <label for="acceptance" style="vertical-align: middle; font-size: small; display: inline"> I agree, to remove all resources, resulting in the account becoming inaccessible upon closure.</label><br>
                    <em v-if="risksCheckBoxError" class="required-text">* Please accept before submitting.</em>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-else >
            <div class="col-12">
              <p>Submitting Account Closure Request. This will just take a moment. Please wait...</p>
            </div>
            <div class="col-12">
              <loading-spinner class="p-0" />
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="offset-md-4 col-md-4">
                <button class="modal-default-button btn flat-btn blue-btn" @click="showConfirmAccountClosureModal()" v-if="!isLoading && !isSuccess" >Submit</button>
              </div>
              <div class="col-md-4">
                <button class="modal-default-button btn flat-btn" @click="close()"  v-if="!isLoading">{{isSuccess?"Close":"Cancel"}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-account-closure-modal
          v-if="displayConfirmAccountClosureModal"
          @submit="submitRequest"
          @close="closeConfirmAccountClosureModal"
      />
    </div>
  </transition>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import api from "@/api";
import util from "@/util";
import * as C from "../../constants.js";
import LoadingSpinner from "../LoadingSpinner.vue";
import ConfirmAccountClosureModal from "@/components/modal/ConfirmAccountClosureModal.vue";

export default {
  name: "AccountClosureRequestModal",
  props: {
    account: Object
  },
  components: {
    ConfirmAccountClosureModal,
    LoadingSpinner
  },
  computed: {
    ...mapGetters(["getAppUser"])
  },
  data: function() {
    return {
      C,
      isLoading: false,
      isFailure: false,
      isSuccess: false,
      requestDescriptionError: false,
      requestDescription: "",
      successResponse: {},
      userName: "",
      risksCheckBox: false,
      risksCheckBoxError: false,
      displayConfirmAccountClosureModal: false
    };
  },
  mounted() {
    this.userName = this.getAppUser.firstName + " " + this.getAppUser.lastName;
  },
  methods: {
    ...mapActions(["addAlert"]),
    close() {
      this.$emit("close");
    },
    showConfirmAccountClosureModal() {
      this.displayConfirmAccountClosureModal = !this.validateForm()
    },
    closeConfirmAccountClosureModal() {
      this.displayConfirmAccountClosureModal = false
    },
    acceptRisks(event) {
      this.risksCheckBox = event.target.checked;
      this.risksCheckBoxError = !event.target.checked;
    },
    validateForm(){
      this.requestDescriptionError = util.stringIsBlank(this.requestDescription)
      this.risksCheckBoxError = !this.risksCheckBox;
      return this.requestDescriptionError || this.risksCheckBoxError;
    },
    async submitRequest() {
      let hasError = this.validateForm();
      if(hasError){
        return;
      }
      this.trackEvent(C.ACTION_TYPES.ACCOUNT_CLOSURE_REQUEST_SUBMIT,
          this.$router.currentRoute.path+"?view=all-corporate-accounts",
          `account_id=${this.account.accountId} name=${this.account.accountCustomName}`);

      this.isLoading = true
      let payload = {
        "accountId": this.account.accountId,
        "requestDescription":  this.requestDescription
      }
      try {
        let resp = await api.submitAccountClosureRequest(payload);

        this.successResponse = resp.data.data
        this.isSuccess = true;
        this.isLoading = false

        this.trackEvent(C.ACTION_TYPES.ACCOUNT_CLOSURE_REQUEST_SUCCESS,
            this.$router.currentRoute.path+"?view=all-corporate-accounts",
            `account_id=${this.account.accountId} name=${this.account.accountCustomName}`);
      } catch (err) {
        console.error("Account Closure Request error", err)
        this.isFailure = true;
        this.isLoading = false

        this.trackEvent(C.ACTION_TYPES.ACCOUNT_CLOSURE_REQUEST_FAILURE,
            this.$router.currentRoute.path+"?view=all-corporate-accounts",
            `account_id=${this.account.accountId} name=${this.account.accountCustomName}`);
      }
    }
  }
};
</script>

<style scoped>
.required-text {
  width: 100%;
  margin-top: .25rem;
  font-family: artifaktElementRegular, Arial, Helvetica, sans-serif;
  font-size: 80%;
  color: #dc3545;
}
.form-control {
  border-radius: 4px;
}
.modal-wrapper {
  text-align: center;
  line-height: 18px;
}
.form-group {
  text-align: left;
}
.status-icon {
  font-size: 50px;
  margin-bottom:20px;
}
.status-title {
  color: #575757;
  font-size: 26px;
}
.status-content {
  font-size: 16px;
  margin-top: 10px;
  text-align: center;
}
.success-icon {
  color: #7ed321;
}
.failure-text {
  color: #ed3131;
  font-size: 14px;
  margin-top:5px;
  margin-bottom:5px;
}
.status-icon svg {
  margin: auto;
  display: block;
}
.btn {
  /*height: 43px;*/
  border-radius: 15px;
  font-family: artifaktElementRegular, Arial, Helvetica, sans-serif;
}
.close-btn {
  font-size: 18px;
  color: white;
}

.close-btn:hover {
  color: white;
}

.modal-header {
  display: block;
  padding: 16px 10px 0;
  margin-bottom: 10px;
  background:  rgba(0, 0, 0, 0.9);
}
.title-text {
  font-family: artifaktElementBold, Arial, Helvetica, sans-serif;
  font-size: 18px;
  padding-bottom: 10px;
  color: white;
}

.modal-body {
  padding: 0px 30px;
  font-family: artifaktElementMedium, Arial, Helvetica, sans-serif;
}

.modal-body p {
  margin-bottom: 5px;
  font-family: artifaktElementRegular, Arial, Helvetica, sans-serif;
}

.modal-footer {
  margin-top: 20px;
  padding: 0;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding-bottom: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-footer {
  display: block;
  border-top: none;
}
.modal-default-button {
  float: right;
  padding: 10px 30px;
  width: 100%;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
@media (max-width: 767px) {
  .modal-default-button {
    margin-bottom: 10px;
  }
}
@media (max-width: 500px) {
  .modal-container {
    width: 100%;
  }
}
</style>